// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_3_wrapper__3yD0H"};